import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandsfreeShoppinginline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M49 18v33a4 4 0 0 1-4 4H19a4 4 0 0 1-4-4V18c0-7.18 7.163-14 17-14s17 6.82 17 14z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M22.778 33h12.444L37 49H21z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26 36v-5.09c0-1.608 1.343-2.91 3-2.91s3 1.302 3 2.91V36",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M36 39h7l1 10" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M15 49h34",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 23.5,
				cy: 57.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 41.5,
				cy: 57.5,
				r: 2.5
			})
		]
	})
});
export default SvgHandsfreeShoppinginline;
